import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { init } from '@jarvis.oddle/core/tools/lib'
import { isFromExternalCode, isFromGlobalCode } from '@jarvis.oddle/core/tools/rollbarHelper'
import { APP_NAME_PATH } from '@jarvis.oddle/core/env'

// TODO: moved to /types folder once fully migrated to ts
declare global {
  interface Window {
    _rollbarConfig: {
      accessToken: string
      captureUncaught: boolean
      captureUnhandledRejections: boolean
      transform: (payload: Record<string, unknown>) => Record<string, unknown>
      checkIgnore: (
        isUncaught: boolean,
        args: unknown,
        payload: Record<string, unknown>
      ) => boolean
      scrubFields: string[]
    }
  }
}

interface ConnectedErrorLoggerProps {
  appVersion: string
  rollbarAccessToken: string
}

/**
 * A rewrite version with typescript support
 * @borrows /core/components/ErrorLogger/ErrorLogger.js
 */
const ConnectedErrorLogger = ({
  appVersion,
  rollbarAccessToken
}: ConnectedErrorLoggerProps): JSX.Element => {
  const reduxState = useSelector((state) => state)

  useEffect(() => {
    if (rollbarAccessToken) {
      window._rollbarConfig = {
        accessToken: rollbarAccessToken,
        captureUncaught: true,
        captureUnhandledRejections: true,
        transform: (payload) => {
          payload.reduxState = reduxState
          payload.code_version = appVersion
          return payload
        },
        checkIgnore: (_isUncaught, _args, payload) => {
          // Ignore all errors outside main javascript bundle
          // This includes: custom script, custom HTML, browser extensions
          return (
            isFromGlobalCode(payload, APP_NAME_PATH) ||
            isFromExternalCode(payload, APP_NAME_PATH)
          )
        },
        scrubFields: ['cardName', 'cvc', 'cardNumber', 'cardExpiry']
      }

      init(
        // TODO: move this constant to a unified folder for tacking
        'https://cdnjs.cloudflare.com/ajax/libs/rollbar.js/2.5.5/rollbar.min.js',
        'rollbar-js'
      )
    }
  }, [appVersion, reduxState, rollbarAccessToken])

  return null
}

export default ConnectedErrorLogger
